// extracted by mini-css-extract-plugin
export default {"root":"AdjacentCoursePauseRequestButton_root__P4cu+"};